import { ProductInterface } from '../../services/exports/Interfaces';
import { PRODUCT_IDENTIFIERS } from '../../services/exports/Constants';
import collect from 'collect.js';
import { useTranslation } from 'react-i18next';

export default function useProductIdentifiers(product: ProductInterface) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Hooks:Menu:UseProductIdentifiers' });

  const identifiers = product?.identifiers ?? [];

  const isVegan = identifiers?.includes(PRODUCT_IDENTIFIERS.VEGAN);
  const isVegetarian = identifiers?.includes(PRODUCT_IDENTIFIERS.VEGETARIAN);

  // Vegan overrides vegetarian
  const filtered = collect(identifiers).when(isVegan && isVegetarian, (collection) =>
    collection.reject((item: string) => item === PRODUCT_IDENTIFIERS.VEGETARIAN),
  );

  const emojis = filtered.map((item) => t(`${item}.emoji`, { defaultValue: null })).whereNotNull();

  const name = product?.name ?? '';
  const prefix = emojis
    .reject((emoji: string) => name.includes(emoji))
    .toArray()
    .join(' ');
  const decoratedName = prefix ? `${prefix} ${name}` : name;

  return {
    identifiers,
    isVegan,
    isVegetarian,
    names: filtered.map((item) => t(`${item}.name`, { defaultValue: item })).whereNotNull(),
    emojis,
    decoratedName,
  };
}
